export enum ChatParticipantType {
   Peer,
   Agent,
   Bot,
}
